import { forwardRef } from "react";

interface WithSelectProps {
  value: string;
  defaultValue: string;
  onChange: (value: string) => void;
  options: { label: string; value: string }[];
}

const withSelect = <P extends object>(
  Component: React.ComponentType<P>,
  MenuItemComponent: React.ComponentType<any>,
  WrapperComponent: React.ComponentType<any>,
) => {
  return forwardRef<any, React.PropsWithChildren<P & WithSelectProps>>(
    ({ value, defaultValue, onChange, options, ...props }, ref) => {
      return (
        <Component
          ref={ref}
          defaultValue={defaultValue}
          value={value}
          onChange={onChange}
          {...(props as P)}>
          {options.map((option) => (
            <MenuItemComponent key={option.value} value={option.value}>
              <WrapperComponent>{option.label}</WrapperComponent>
            </MenuItemComponent>
          ))}
        </Component>
      );
    },
  );
};

export { withSelect, type WithSelectProps };
